module.exports = __webpack_public_path__ + "static/media/iran3.931abc0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/iran3.jpg
// module id = 257
// module chunks = 0